module.exports = __webpack_public_path__ + "img/4.e4bfb659.png";